class SiderBarFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const sidebarForm = this.querySelector('form');
    sidebarForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const sidebarWrapper = this.querySelector('#sidebarWrapperDesktop');
    if (sidebarWrapper) sidebarWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : SiderBarFiltersForm.searchParamsInitial;
      if (searchParams === SiderBarFiltersForm.searchParamsPrev) return;
      SiderBarFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActivesidebar(disable = true) {
    document.querySelectorAll('.js-sidebar-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    SiderBarFiltersForm.searchParamsPrev = searchParams;
    const sections = SiderBarFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('product-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    
    if (countContainerDesktop){
      countContainerDesktop.parentElement.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      SiderBarFiltersForm.filterData.some(filterDataUrl) ?
        SiderBarFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        SiderBarFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) SiderBarFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        SiderBarFiltersForm.filterData = [...SiderBarFiltersForm.filterData, { html, url }];
        SiderBarFiltersForm.renderFilters(html, event);
        SiderBarFiltersForm.renderProductGridContainer(html);
        SiderBarFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = SiderBarFiltersForm.filterData.find(filterDataUrl).html;
    SiderBarFiltersForm.renderFilters(html, event);
    SiderBarFiltersForm.renderProductGridContainer(html);
    SiderBarFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('product-count');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.parentElement.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const sidebarDetailsElements =
      parsedHTML.querySelectorAll('#SiderBarFiltersForm .js-filter, #SiderBarFiltersFormMobile .js-filter, #sidebarFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const sidebarToRender = Array.from(sidebarDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(sidebarDetailsElements).find(matchesIndex);

    sidebarToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    SiderBarFiltersForm.renderActivesidebar(parsedHTML);
    SiderBarFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) SiderBarFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActivesidebar(html) {
    const activeSidebarElementSelectors = ['.active-sidebar-mobile', '.active-sidebar-desktop'];

    activeSidebarElementSelectors.forEach((selector) => {
      const activesidebarElement = html.querySelector(selector);
      if (!activesidebarElement) return;
      document.querySelector(selector).innerHTML = activesidebarElement.innerHTML;
    })

    SiderBarFiltersForm.toggleActivesidebar(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-sidebar-open', '.mobile-sidebar-count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('SiderBarFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.sidebar-selected');
    const sourceElement = source.querySelector('.sidebar-selected');

    const targetElementAccessibility = target.querySelector('.widget-title');
    const sourceElementAccessibility = source.querySelector('.widget-title');

    if (sourceElement && targetElement) {
      target.querySelector('.sidebar-selected').outerHTML = source.querySelector('.sidebar-selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.widget-title').outerHTML = source.querySelector('.widget-title').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    SiderBarFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('sidebar-filters-form form');
    if (event.srcElement.className == 'mobile-sidebar__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'SiderBarFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'sidebarortForm' || form.id === 'SiderBarFiltersForm' || form.id === 'sidebarortDrawerForm' || form.id === 'sidebarFilterActiveForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'SiderBarFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    SiderBarFiltersForm.toggleActivesidebar();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    SiderBarFiltersForm.renderPage(url);
  }
}

SiderBarFiltersForm.filterData = [];
SiderBarFiltersForm.searchParamsInitial = window.location.search.slice(1);
SiderBarFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('sidebar-filters-form', SiderBarFiltersForm);
SiderBarFiltersForm.setListeners();


class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
    this.loadRangePrice();
    
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.loadRangePrice();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
  
  loadRangePrice() {
    var parent = this.querySelector(".widget-price-wrapper");
    if (!parent) return;
    var rangeS = this.querySelectorAll("input[type=range]"),
        numberS = this.querySelectorAll("input[type=number]");
    
    rangeS.forEach(function (el) {
      el.oninput = function () {
        var slide1 = parseFloat(rangeS[0].value),
            slide2 = parseFloat(rangeS[1].value);
        if (slide1 > slide2) {
          [slide1, slide2] = [slide2, slide1];
        }
        numberS[0].value = slide1;
        numberS[1].value = slide2;
        
      };
    });
    numberS.forEach(function (el) {
      el.oninput = function () {
        var number1 = parseFloat(numberS[0].value),
            number2 = parseFloat(numberS[1].value);

        if (number1 > number2) {
          var tmp = number1;
          numberS[0].value = number2;
          numberS[1].value = tmp;
        }
        rangeS[0].value = number1;
        rangeS[1].value = number2;
      };
    });    
  }
}

customElements.define('price-range', PriceRange);

class SidebarRemove extends HTMLElement {
  constructor() {
    super();
    const sidebarLink = this.querySelector('a');
    sidebarLink.setAttribute('role', 'button');
    sidebarLink.addEventListener('click', this.closeFilter.bind(this));
    sidebarLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('sidebar-filters-form') || document.querySelector('sidebar-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('sidebar-remove', SidebarRemove);

// Sort by filter active
class sortBy extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onSortChange);
     this.onBodyClickSort = this.handleBodyClickSort.bind(this);
  }

  onSortChange(event){
    event.preventDefault();
    if(event.target.classList.contains('sortby-button')){
      event.target.parentElement.parentElement.parentElement.classList.contains('active') ?  event.target.parentElement.parentElement.parentElement.classList.remove('active') :  event.target.parentElement.parentElement.parentElement.classList.add('active');
      document.body.addEventListener('click', this.onBodyClickSort);
    }
  }

   handleBodyClickSort(evt) {
    const target = evt.target;
    if (!event.target.classList.contains('sortby-button') && !target.closest('.filter-sort-by-conatiner')) {
      this.parentElement.parentElement.classList.contains('active') ?  this.parentElement.parentElement.classList.remove('active') :  '';
      document.body.removeEventListener('click', this.onBodyClickSort);
    }
  }

}

customElements.define('sort-select', sortBy);
